<template>
  <div class="donation-form__fund-information">
    <img
      :src="memorialFund.image"
      :alt="memorialFund.name"
      :title="memorialFund.name"
    />

    <p v-if="showFull || !shouldTruncate" v-html="description" />
    <p v-else v-text="truncatedDescription" />

    <button
      v-if="!showFull && shouldTruncate"
      type="button"
      class="donation-form__read-more"
      @click.prevent="showFull = true"
    >
      {{ texts.readMore }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CreateCommentFundInformation',

  props: {
    memorialFund: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      showFull: false,
      texts: lavendlaObituary.createComment,
    };
  },

  computed: {
    ...mapState('donations', ['description']),
    plainTextDescription() {
      // Strip HTML tags and normalize whitespace for accurate character counting
      const tmp = document.createElement('div');
      tmp.innerHTML = this.description || '';
      const text = tmp.textContent || tmp.innerText || '';
      return text.replace(/\s+/g, ' ').trim();
    },
    shouldTruncate() {
      return this.plainTextDescription.length > 150;
    },
    truncatedDescription() {
      if (!this.plainTextDescription) return '';
      const snippet = this.plainTextDescription
        .slice(0, 150)
        .replace(/\s+$/, '');
      return `${snippet}…`;
    },
  },
};
</script>

<style></style>
